<template lang="pug">
div(
    :class="{ bordered: bordered }"
    class="tl-card"
)
    slot
</template>

<script lang="ts" setup>
import { computed, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    bordered: Boolean,
})

const injects = getInjects(props, inject)

const bordered = computed(() => props.bordered ?? injects.bordered?.value)
</script>

<style lang="sass" scoped>
.tl-card
    padding: var(--padding-5)
    border-radius: var(--border-radius)
    background-color: var(--color-white)
    transition: var(--transition-default)
    box-shadow: 0 0px 0px -10px rgba(0,0,0,0.0)
    &.bordered
        box-shadow: none
        padding: var(--padding-6)
        border: 1px solid var(--color-tint-light)
</style>
